import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowRelatedTextConverter extends CmsConverterService<PanelRowRelatedTextData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      text: formData.st_text ?? defaultTextInput
    }
  }
}

export const PANEL_ROW_RELATED_TEXT_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowRelatedTextData>>('PanelRowRelatedTextConverter')

export interface PanelRowRelatedTextData extends ConvertedComponentData {
  text: TextInput;
}
